export const useApiStore = defineStore('api', () => {
  const loadingByContext = reactive<{ [key: string]: number }>({})

  const $reset = () => {
    Object.keys(loadingByContext).forEach((key) => {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete loadingByContext[key]
    })
  }

  const isLoading = computed(() => (loadingByContext['page'] ?? 0) > 0)
  const isLoadingDialog = computed(() => (loadingByContext['dialog'] ?? 0) > 0)

  const startLoading = (context: string = 'page') => {
    loadingByContext[context] = (loadingByContext[context] ?? 0) + 1
  }

  const stopLoading = (context: string = 'page') => {
    if (loadingByContext[context] !== undefined && loadingByContext[context] > 0) {
      loadingByContext[context]--
    }
  }

  return { isLoading, isLoadingDialog, startLoading, stopLoading, $reset }
})
